import { Component, OnInit, HostListener, AfterViewInit } from '@angular/core';
import { MenuService } from '../menu.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService } from '../services/auth.service';


import * as bootstrap from 'bootstrap';


interface SubMenu {
  name: string;
  route: string;
  isActive: boolean | string; // Updated type to handle routerLinkActive return type
  icon?: string; // Tambahkan property icon sebagai optional
}

interface MenuItem {
  name: string;
  route: string;
  subItems: SubMenu[];
  isActive: boolean | string; // Updated type to handle routerLinkActive return type
  isSubmenuOpen: boolean;
  icon?: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  menuItems: MenuItem[] = [];
  menuActive = false;
  isMobile: boolean = window.innerWidth <= 767;
  isTablet: boolean = window.innerWidth > 767 && window.innerWidth <= 1024;
  showNavigation = true;
  currentRoute: string = '';


  showBadge: boolean = false;

  whatsappUrl: string = "https://wa.me/628114340665";

  constructor(
    private menuService: MenuService, 
    private router: Router, 
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,  
  ) {
    this.router.events.subscribe((event: any) => {
      if (event.url) {
        this.currentRoute = event.url;
        this.showNavigation = !event.url.includes('/l_admin');
        this.updateMenuActiveState();
      }
    });
  }





  ngOnInit(): void {

    
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updatePropertiesBasedOnRoute(event.urlAfterRedirects);
      }
    });

    // Untuk mendukung inisialisasi pertama
    this.updatePropertiesBasedOnRoute(this.router.url);


    if (this.showNavigation) {
      this.menuService.getMenu().subscribe(data => {
        const userLoggedIn = localStorage.getItem('user_pelanggan');
        const adminLoggedIn = localStorage.getItem('user');

        const filtered = adminLoggedIn && !userLoggedIn
          ? data.filter((item: any) => item.icon !== 'fas fa-shopping-cart')
          : data;

        this.menuItems = filtered.map((item: any) => {
          if (item.name === 'Login') {
            if (userLoggedIn) {
              return {
                name: '', // Empty name since we're using icon
                route: '#',
                icon: 'fas fa-user-circle',
                isSubmenuOpen: false,
                isActive: false,
                subItems: [
                  { name: 'Messages', route: '/messages', icon: 'fas fa-envelope', isActive: false },
                  { name: 'Bookings', route: '/bookings', icon: 'fas fa-calendar', isActive: false },
                  { name: 'Manage Account', route: '/account', icon: 'fas fa-cog', isActive: false },
                  { name: 'Logout', route: '/logout', icon: 'fas fa-sign-out-alt', isActive: false }
                ]
              };
            }
            if (adminLoggedIn) {
              return {
                name: 'Admin Panel',
                route: '/l_admin',
                subItems: [],
                isSubmenuOpen: false,
                isActive: false,
              };
            }
          }
          return {
            ...item,
            isSubmenuOpen: false,
            isActive: false,
            subItems: item.subItems.map((subItem: SubMenu) => ({
              ...subItem,
              isActive: false
            }))
          };
        });
  
        this.updateMenuActiveState();
      });
    }

    this.authService.badge$.subscribe((show) => {
      this.showBadge = show;
    });
    this.authService.checkLocalStorage();

  }


  ngAfterViewInit(): void {
      // Inisialisasi tooltip Bootstrap setelah tampilan ter-render
      var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
      });
  }
  





  isActiveRoute(route: string, subItems: SubMenu[] = []): boolean {
    if (!route) {
      // If no direct route (like in parent menus with only subItems)
      return subItems.some(subItem => this.currentRoute.includes(subItem.route));
    }
    return this.currentRoute.includes(route) || 
           subItems.some(subItem => this.currentRoute.includes(subItem.route));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = event.target.innerWidth <= 767;
    this.isTablet = event.target.innerWidth > 767 && event.target.innerWidth <= 1024;
  }

  updateMenuActiveState(): void {
    const currentUrl = this.router.url;
  
    this.menuItems.forEach(item => {
      // Check if any submenu is active
      const hasActiveSubmenu = item.subItems.some(subItem => 
        currentUrl === subItem.route || currentUrl.startsWith(subItem.route)
      );
  
      // Update submenu active states
      item.subItems.forEach(subItem => {
        subItem.isActive = currentUrl === subItem.route || currentUrl.startsWith(subItem.route);
      });
  
      // Set parent menu active if it has an active submenu or its own route is active
      item.isActive = hasActiveSubmenu || (item.route && (currentUrl === item.route || currentUrl.startsWith(item.route)));
    });
  }

  // Helper method to check if a menu item should show as active
  isMenuActive(item: MenuItem): boolean {
    return Boolean(item.isActive);
  }

  isMenuActive2(route: string): boolean {
    const currentUrl = this.router.url;
    // Aktif jika route adalah '/login-pelanggan' dan URL cocok dengan '/login-pelanggan' atau '/login-pelanggan/whatsapp'
    if (route === '/login-pelanggan') {
      return currentUrl === '/login-pelanggan' || currentUrl === '/login-pelanggan/whatsapp';
    }
    // Logika default untuk menu lainnya
    return currentUrl === route;
  }


  // Helper method to check if a submenu item should show as active
  isSubmenuActive(subItem: SubMenu): boolean {
    return Boolean(subItem.isActive);
  }

  toggleMenu() {
    this.menuActive = !this.menuActive;
  }

  toggleSubmenu(event: any, item: MenuItem) {
    event.preventDefault();
    event.stopPropagation();
    
    // Close all other submenus
    this.menuItems.forEach(menuItem => {
      if (menuItem !== item) {
        menuItem.isSubmenuOpen = false;
      }
    });
    
    // Toggle the clicked submenu
    item.isSubmenuOpen = !item.isSubmenuOpen;
    
    // Add/remove open class to parent li for rotation animation
    const parentLi = (event.target as HTMLElement).closest('.nav-item');
    if (parentLi) {
      if (item.isSubmenuOpen) {
        parentLi.classList.add('open');
      } else {
        parentLi.classList.remove('open');
      }
    }
  }

  closeSubmenus() {
    this.menuItems.forEach(item => item.isSubmenuOpen = false);
  }

  logout(event: Event): void {
    event.preventDefault();
  
  
  
    // Menghapus data sesi
    localStorage.removeItem('authToken');
    localStorage.removeItem('user_pelanggan');

    window.location.reload();
  }

  isSticky: boolean = false;
  showBackTop: boolean = false;
  imageUrl: string = 'assets/img/logo_2.png';
  warna: string = '#F2F2F2';


  private updatePropertiesBasedOnRoute(url: string): void {
    if ( url === '/login-pelanggan' || 
         url === '/login-pelanggan/whatsapp' || 
         url.startsWith('/signup-pelanggan') || 
         url.startsWith('/detail-boat') ||
         url.startsWith('/detail-boatopen') ||
         url === '/checkout' || 
         url === '/bookings' ||
         url.startsWith('/account') ||
         url.startsWith('/detail-booking') ||
         url.startsWith('/search-results')
        ) {
      this.isSticky = true;
      this.showBackTop = true;
      this.imageUrl = 'assets/img/logo.png';
      this.warna = '#025159';
    } else {
      this.isSticky = false;
      this.showBackTop = false;
      this.imageUrl = 'assets/img/logo_2.png';
      this.warna = '#F2F2F2';
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (!this.router.url.includes('/login-pelanggan') &&
        !this.router.url.includes('/login-pelanggan/whatsapp')&&
        !/\/signup-pelanggan(\/.*)?/.test(this.router.url) &&
        !/\/detail-boat(\/.*)?/.test(this.router.url) &&
        !/\/detail-boatopen(\/.*)?/.test(this.router.url) &&
        !this.router.url.includes('/checkout')  &&
        !this.router.url.includes('/bookings') &&
        !/\/account(\/.*)?/.test(this.router.url) &&
        !/\/detail-booking(\/.*)?/.test(this.router.url) &&
        !/\/search-results(\/.*)?/.test(this.router.url)
  ){
      if (scrollPosition < 400) {
        this.isSticky = false;
        this.showBackTop = false;
        this.imageUrl = 'assets/img/logo_2.png';
        this.warna = '#F2F2F2';
      } else {
        this.isSticky = true;
        this.showBackTop = true;
        this.imageUrl = 'assets/img/logo.png';
        this.warna = '#025159';
      }
    }
  }


  onMenuItemClick(): void {
    if (this.isMobile) {
      this.menuActive = false; // Tutup menu mobile setelah klik
      this.closeSubmenus();    // Tutup juga semua submenu
    }
  }

  handleSubmenuClick(event: Event, subItem: SubMenu): void {
  if (subItem.name === 'Logout') {
    this.logout(event);
  } else {
    this.onMenuItemClick(); // Tutup menu setelah klik submenu biasa
  }
}
}


